'use client';
import { jsx, jsxs, Fragment } from "react/jsx-runtime";
import { Slot } from "@radix-ui/react-slot";
import { cn } from "@tameeni/shared-logic";
import * as React from "react";
import { Spinner } from "../loaders/spinner.js";
import { buttonVariants } from "./button.variants.js";
const Button = React.forwardRef(
  ({
    id,
    className,
    variant,
    size,
    colorPalette,
    asChild = false,
    loading,
    loadingText,
    // Handle both legacy and new icon props
    icon,
    iconPosition = "start",
    startIcon,
    endIcon,
    children,
    type = "button",
    isContentCentered = true,
    ...props
  }, ref) => {
    const Comp = asChild ? Slot : "button";
    const finalStartIcon = startIcon || (icon && iconPosition === "start" ? icon : void 0);
    const finalEndIcon = endIcon || (icon && iconPosition === "end" ? icon : void 0);
    const LoadingComp = loadingText ? /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx(Spinner, {}),
      /* @__PURE__ */ jsx("span", { children: loadingText })
    ] }) : /* @__PURE__ */ jsx(Spinner, {});
    const renderContent = () => {
      if (loading) return LoadingComp;
      const startIconElement = finalStartIcon && /* @__PURE__ */ jsx("span", { className: "flex-shrink-0", "aria-hidden": "true", children: finalStartIcon });
      const endIconElement = finalEndIcon && /* @__PURE__ */ jsx("span", { className: "flex-shrink-0", "aria-hidden": "true", children: finalEndIcon });
      const textElement = children && /* @__PURE__ */ jsx("div", { children });
      return /* @__PURE__ */ jsxs(
        "div",
        {
          className: cn(
            `flex items-center w-full gap-2`,
            isContentCentered ? "justify-center" : "justify-between",
            startIcon && endIcon && "justify-between"
          ),
          children: [
            startIconElement,
            textElement && /* @__PURE__ */ jsx(
              "div",
              {
                className: isContentCentered ? "overflow-hidden self-center" : "overflow-hidden",
                children: textElement
              }
            ),
            endIconElement
          ]
        }
      );
    };
    return /* @__PURE__ */ jsx(
      Comp,
      {
        className: cn(
          buttonVariants({ variant, size, colorPalette, className }),
          "inline-flex items-center justify-center",
          startIcon && endIcon && "justify-between"
        ),
        ref,
        disabled: loading || props.disabled,
        type,
        ...props,
        children: renderContent()
      }
    );
  }
);
Button.displayName = "Button";
export {
  Button,
  buttonVariants
};
